import axios from 'axios'
import { BASE_PATH_PORTAL } from '../../constants'

export const getInquiryList = async () => {
  return axios.get(`${BASE_PATH_PORTAL}/data/iesniegumu_saraksts?offset=0&limit=10`).then((response) => response.data)
}
